import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EditComponent} from './edit.component';
import {AgmCoreModule} from "@agm/core";
import {ReactiveFormsModule} from "@angular/forms";
import {BaseModule} from "../../../../base/base.module";
import {SharedModule} from "../../../../shared/shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    BaseModule,
    SharedModule,
    AgmCoreModule.forRoot(),
    ReactiveFormsModule
  ],
  declarations: [EditComponent]
})
export class EditModule {
}
